import { render, staticRenderFns } from "./weditorUser.vue?vue&type=template&id=1baa72dc"
import script from "./weditorUser.vue?vue&type=script&lang=js"
export * from "./weditorUser.vue?vue&type=script&lang=js"
import style0 from "./weditorUser.vue?vue&type=style&index=0&id=1baa72dc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports